import React from 'react'
import PropTypes from 'prop-types'
import { FeedbackBase, FeedbackIcon, FeedbackTitle, FeedbackSubTitle } from './styles'

const Feedback = ({ icon, title, subtitle, id, withBorderTop }) => (
  <FeedbackBase data-testid={id} withBorderTop={withBorderTop}>
    <FeedbackTitle>{title}</FeedbackTitle>
    <FeedbackIcon>{icon}</FeedbackIcon>
    {subtitle && <FeedbackSubTitle> {subtitle}</FeedbackSubTitle>}
  </FeedbackBase>
)

Feedback.propTypes = {
  icon: PropTypes.instanceOf(Object),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  id: PropTypes.string.isRequired,
  withBorderTop: PropTypes.bool,
}

export default Feedback
